import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link, useParams } from 'react-router-dom';
import WelcomeImage from '../../Components/ImagesWithElements/WelcomeImage';
import styled from "styled-components";
import PasswordInput from '../../Components/PasswordInput';
import usePortalService from '../../services/PortalService';
 
const Styles = styled.div`
div {
    color: var(--grey-grey-8, #717171);
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
}
`

let link = '';
export default function NewPassword() {
    const {resetPassword} = usePortalService();
    const navigate = useNavigate();
    const params = useParams();
    link = params.code as string;

    const [password, setPassword] = useState('');
    const [passwordDirty, setPasswordDirty] = useState(false);
    const [passwordError, setPasswordError] = useState('Пароль не может быть пустым');

    const [confirmPassword, setConfirmPassword] = useState('');
    const [confirmPasswordDirty, setConfirmPasswordDirty] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState('Пароль не может быть пустым');

    const [resetPasswordError, setResetPasswordError] = useState('');

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'password':
                setPasswordDirty(true)
                break;
            case 'confirmPassword':
                setConfirmPasswordDirty(true)
                break;
        }
    }

    const passwordHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
        if (e.target.value.length < 8) {
            setPasswordError('Длина пароля не может быть меньше 8 символов')
        } else {
            setPasswordError('')
        }
        if (e.target.value != confirmPassword) {
            setConfirmPasswordError('Пароли не совпадают')
        }
        else {
            setConfirmPasswordError('')
        }
    }

    const confirmPasswordHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(e.target.value)
        if (e.target.value != password) {
            setConfirmPasswordError('Пароли не совпадают')
        }
        else {
            setConfirmPasswordError('')
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (passwordError || confirmPasswordError) {
            setPasswordDirty(true);
            setConfirmPasswordDirty(true);
        }
        else {
            const result = await resetPassword({
                link,
                password
            });
            if (result.success) {
                navigate("/");
            } else {
                setResetPasswordError(result.errors)
            }
        }
    }

    return (
        <Styles>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <WelcomeImage/>
                </section>
                <div className="content" >
                    <div className="auth-content">
                        <h1 style={{ marginBottom: '8px' }}> Сбросить пароль </h1>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="form-group" controlId="formPassword">
                                <Form.Label> Пароль </Form.Label>
                                <PasswordInput 
                                    name="password" 
                                    value={password} 
                                    onChange={e => passwordHandler(e)} 
                                    onBlur={e => blurHandler(e)} 
                                    placeholder="8+ символов"
                                    isInvalid={!!(passwordDirty && passwordError)}  
                                />
                                {(passwordDirty && passwordError) && <p className="error-alert">{passwordError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group" controlId="formConfirmPassword">
                                <Form.Label> Повтор пароля </Form.Label>
                                <PasswordInput name='confirmPassword'
                                    value={confirmPassword} 
                                    onBlur={e => blurHandler(e)} 
                                    onChange={e => confirmPasswordHandler(e)}
                                    isInvalid={!!(confirmPasswordDirty && confirmPasswordError)} 
                                />
                                {(confirmPasswordDirty && confirmPasswordError) && <p className="error-alert">{confirmPasswordError}</p>}
                            </Form.Group>
                            <br />
                            <Button variant="primary" type="submit" style={{width: '173px', height: '40px'}}> Сохранить </Button>
                            <p className="error-alert">{resetPasswordError}</p>
                            {(resetPasswordError) && <Link to="/forgotPassword"> Восстановить пароль </Link>}
                        </Form>
                    </div>
                </div>
            </div>
        </Styles>
    );
};